
const getters = {
  inner:state=>state.application.inner,
  showMenu:state=>state.application.showMenu,
  userInfo:state=>state.user.userInfo,
  originRoutes:state=>state.application.originRoutes,
  usedRouter:state=>state.application.usedRouter
}

export default getters